<div class="flex p-2 items-center gap-3 cursor-pointer" (click)="openDocument(message)">
  <i class="pi pi-file text-2xl"></i>
  <div class="flex flex-col">
    <span class="font-medium">{{ message.fileName || 'Documento' }}</span>
    <span class="text-xs text-color-secondary">Clicca per aprire</span>
  </div>
</div>
